module.exports = __webpack_public_path__ + "static/media/dropoff_pass.e3cb5dcd.svg";